import { useIsFetching } from "@tanstack/react-query"

import { EQUIPMENT_ROOT_QUERY_KEY } from "./queries/equipment/queryKeys"

export function useIsFetchingEquipment() {
    const isFetchingEquipmentLayers = useIsFetching({ queryKey: [EQUIPMENT_ROOT_QUERY_KEY, "layer"] })

    return isFetchingEquipmentLayers > 0
}